export const SHOW_LOADING = "showLoading";
export const HIDE_LOADING = "hideLoading";
export const SHOW_FLASH_MESSAGE = "showFlashMessage";
export const HIDE_FLASH_MESSAGE = "hideFlashMessage";
export const LOGIN = "login";
export const LOGOUT = "logout";
